import axios from 'axios'
import { Message } from 'element-ui'
import {showLoadingSpinner,hideLoadingSpinner} from './loading.js'
import store from '@/store'
import { handleSessionExpired } from './auth'
// create an axios instance
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
const service = axios.create({
  baseURL: '/apiip',// url = base url + request url
  timeout: 86400000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['userToken'] = store.getters.token
    }
    showLoadingSpinner()
    return config
  },
  error => {
    hideLoadingSpinner()
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    if ((response?.data?.code ? response?.data?.code : response?.data[0]?.code) != 200) {
      hideLoadingSpinner()
      return Promise.resolve(response.data)
    }
    hideLoadingSpinner()
    return Promise.resolve(response.data)
  },
  error => {
    // token过期/未授权:后端jwt过期会以500透传"Signature has expired."(2026-09-21 会话策略:
    // token为24h纯凭证+前端45分钟滑动空闲超时,此处兜底防过期后卡死在报错页)
    const respText = JSON.stringify(error.response?.data || '')
    if (error.response?.status === 401 || respText.indexOf('Signature has expired') !== -1 || respText.indexOf('Token') !== -1 && respText.indexOf('expire') !== -1) {
      hideLoadingSpinner()
      handleSessionExpired()
      return Promise.reject(error.response?.data)
    }
    Message({
      dangerouslyUseHTMLString: true,
      message: error.response?.data?.message || '请求失败',
      type: 'error',
      duration: 5 * 1000
    })
    hideLoadingSpinner()
    return Promise.reject(error.response?.data)
  }
)

export default service
